export default __webpack_public_path__ + "static/dashboard-thumb-2-ph-07465dcfa7d2e8063378220c9db80477.webp";